// React Dependencies
import React, {Component} from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import $ from 'jquery';

import { slideNav } from '../../flux/functions';
import { fitthevids } from '../../flux/fitvids';

import { setFancyBox } from '../../flux/functions';

import logodeco from '../../assets/img/logo-decojovem.svg';

import Helmet from 'react-helmet';

// IMPORT Paths
import URL from '../../flux/path';
export default class Header extends Component {
	constructor(props){
		super(props);
		this.state = { menus: [], temas: [] };
	}
	componentWillMount(){
		this.getMenu();
		this.getTemas();
	}
	componentDidUpdate(){
		$(".home-header, .post-body, .item-video").fitVids();
		setFancyBox();
	}
	componentDidMount(){
		window.scrollTo(0,0);
		fitthevids();
		setFancyBox();
		$(".home-header, .post-body, .item-video").fitVids();
		$(document).on('click', 'nav a', function(){
			$('#main-nav').removeClass('open');
			$('#burger').removeClass('is-active');
			if ( $(this).text() == 'Início' ){
				$('body').css('margin-bottom', 352);
			}
		})
		$('#burger, .main-hashtag').on('click', function(){
			$(this).toggleClass('is-active');
			$(this).parent().find('#main-nav').toggleClass('open');
		});
		$(document).on('click', '.menu-item', function(event) {
			if ($(this).hasClass('menu-item-has-children')) {
				$('.sub-menu').toggleClass('open');
				//event.preventDefault();
			}
		});
		$(document).on('click', '#temas', function(event){
			event.preventDefault();
		})
	}
	getMenu(){
		fetch(URL.menus)
		.then(res => res.json())
		.then(res => {
		  this.setState({
			menus: res.items
		  })
		  })
	}
	getTemas(){
		axios.get( URL.temas ).then(res => {
			this.setState({ temas: res.data });
		});
	}

	render(){
		$('#temas').parent().append('<ul class="sub-menu"></ul>');
		let menu_link = null;
		let menus = this.state.menus.map((menu, index) => {
			if ( menu.title == 'Início' || menu.object_slug == 'inicio' ) {
				menu_link = <Link key={menu.title} to={`${process.env.PUBLIC_URL}/`}>{menu.title}</Link>;
			} else if ( menu.title == 'Temas'  || menu.object_slug == 'temas' ){
				menu_link = <Link id="temas" key={menu.title} to={`${process.env.PUBLIC_URL}#`} >{menu.title}</Link>;
			} else {
				menu_link = <Link key={menu.title} to={{
					pathname: `${process.env.PUBLIC_URL}/${menu.object_slug}`,
					state: menu.object_slug
				}}>{menu.title}</Link>;
			}
			return(
				<li id="menu-item-4" className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-4">
					{menu_link}
				</li>
			)
		});
		if( this.state.temas != '' && !$('.menu-item-e')[0] ){
			$('#temas').parent().addClass('menu-item-has-children');
			this.state.temas.map((tema, index) => {
				$('.sub-menu').append('<li class="menu-item-e"> <a href="https://decojovem.pt/iniciativa/mundon/temas/' + tema.slug + '">' + tema.title.rendered + '</a></li>')
			});
		}
		return(
			<div>
				<Helmet>
					<meta charset="utf-8" />
					<title>MundOn - uma iniciatia DECOJovem</title>
					<meta name="viewport" content="width=device-width, initial-scale=1" />
					<meta name="robots" content="noodp, noydir" />
					<meta name="description" content="O Mundo ON é o projeto que incentiva os jovens enquanto consumidores a adotar comportamentos de consumo mais sustentáveis, a reduzir os consumos, a efetuar escolhas mais responsáveis e fazer um uso mais eficiente dos recursos naturais." />
					<meta property="og:image" content="https://decojovem.pt/iniciativa/mundon/static/mundon.jpg" />
					<meta property="og:title" content="MundOn - uma iniciatia DECOJovem" />
					<link rel="icon" type="image/x-icon" href="https://decojovem.pt/iniciativa/mundon/favicon.ico" />
					<link rel="icon" type="image/png" href="https://decojovem.pt/iniciativa/mundon/favicon.ico" />
				</Helmet>
				<header role="banner" className="main-header" id="main-header">
					<a className="logo-decojovem" href="https://decojovem.pt/" target="_blank" rel="noopener noreferrer">
						<img src={logodeco} alt="DecoJovem" />
					</a>
					<a href="https://decojovem.pt/iniciativa/mundon" className="main-hashtag">#mundon</a>
					<nav className="main-nav" id="main-nav">
						<ul className="menu">
							{menus}
						</ul>
					</nav>
					<div className="hamburger hamburger--arrowturn" aria-label="Menu" aria-controls="navigation" id="burger">
						<div className="hamburger-box">
							<div className="hamburger-inner"></div>
						</div>
					</div>
				</header>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/header/header.js